module.exports = __webpack_public_path__ + "media/books/Books-Focus-3-10eb3b95.png";